import useSirenEntity from '~/utility/use-siren-entity';
import useStore from '~/utility/use-store';

const isMillBinsGroup = org => org?.getSubEntityByRel('https://api.binsentry.com/rel/organization-type')?.properties.name === 'mill-bins-group';

export function useMillBinsGroup() {
  const { currentOrgHref, queryV2 } = useStore(['currentOrgHref', 'queryV2']);
  const orgId = queryV2?.organizationId || queryV2?.orgId || currentOrgHref;
  const { entity: orgEntity, loading: loadingOrg } = useSirenEntity({ href: orgId });
  const orgIsBinsGroup = isMillBinsGroup(orgEntity);

  const childrenHref = orgIsBinsGroup ? undefined : orgEntity?.getSubEntityByRel('https://api.binsentry.com/rel/organization-children')?.href;
  const { entity: organizationChildrenEntity, loading: loadingChildren } = useSirenEntity({ href: childrenHref });

  const millBinsGroup = orgIsBinsGroup ? orgEntity : organizationChildrenEntity?.getSubEntities('item').find(isMillBinsGroup);
  const loading = loadingOrg || loadingChildren;

  return { millBinsGroup, loading };
}
